import * as React from 'react';
import cx from 'classnames';
import { Collapse } from '../Icons';

interface SidebarWrapperProps {
  title?: string;
  width?: number | string;
  children?: React.ReactNode;
}

export default function SidebarWrapper({
  title = '',
  width = 200,
  children,
}: SidebarWrapperProps) {
  const [isExpanded, setIsExpanded] = React.useState<boolean>(true);

  return (
    <div className="sidebar-wrapper">
      <div className={cx('h-full', { relative: isExpanded })}>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={cx(
            'flex absolute z-10 w-full justify-end',
            isExpanded
              ? 'h-10 items-center'
              : 'w-full h-full top-0 right-0 pt-4 pr-5'
          )}
        >
          <Collapse
            width={20}
            height={20}
            className={cx('h-10', {
              'rotate-180': !isExpanded,
            })}
          />
        </button>
        <div
          className={cx('content transition-all duration-200 ease-in', {
            'opacity-0 duration-300 ease-out': !isExpanded,
          })}
          style={{
            width: isExpanded ? width : 10,
          }}
        >
          <p className="w-full h-10 leading-10 pr-4 whitespace-nowrap">
            {title}
          </p>
          <div className="content-area">{children}</div>
        </div>
      </div>
    </div>
  );
}
